module.exports = __webpack_public_path__ + "static/img/king_card_2.8681ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/king_card_2.png
// module id = K5M0
// module chunks = 0